export default __webpack_public_path__ + "assets/amenities.19f2ee8b.svg";